import {Component, OnInit, Inject} from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { UsersService } from './users.service';
import { NotifyService } from '../shared/services/notify.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  users:any[] = [];
  uForm: FormGroup;
  sortfield:string = 'name';
  sortAsc:boolean = true;

  constructor(
    @Inject(FormBuilder) fb: FormBuilder,
    private _appService: AppService,
    private _userService: UsersService,
    private _notifyService: NotifyService
  ) {

    this.uForm = fb.group({
      _id: [null],
      firstName:[null],
      lastName:[null],
      username:[null,Validators.required],
      saw:[false,null],
      active:[false,null],
      role:['Staff',null],
      password:[null]
    });

  }

  ngOnInit() {
    this.getUsers();
  }

  private getUsers() {
    this._userService.getUsers().subscribe(
      data => {
        this.users = data.users;
        this._appService.hideLoader();
      }
    );
  }

  cancel() {
    this.uForm.reset();
  }

  saveUser() {
    if(this.uForm.get('_id').value)
    {
      this._appService.showLoader();
      this._userService.editUser(this.uForm.value).subscribe(
        data => {
          this.cancel();
          for(let q = 0; q<this.users.length; q++) {
            let u = this.users[q];
            if(u._id == data.user._id) {
              this.users[q] = data.user;
            }
          }
          setTimeout(()=> {
            this._notifyService.setNote({
              styleClass: 'alert-success',
              heading: 'Success!',
              body: 'User Saved'
            });
            this._appService.hideLoader();
          }, 1000);
        },
        error => {
          this._appService.hideLoader();
          this._notifyService.setNote({
            styleClass: 'alert-danger',
            heading: 'Error!',
            body: error
          });
        }
      );
    } else {
      const pass = this.uForm.get('password').value;
      if(!pass) {
        this._notifyService.setNote({
          styleClass: 'alert-danger',
          heading: 'Error!',
          body: 'Don\'t forget the password!'
        });
        return;
      }
      this._appService.showLoader();
      this._userService.saveUser(this.uForm.value).subscribe(
        data => {
          this.cancel();
          this.users.unshift(data.user);
          setTimeout(()=> {
            this._notifyService.setNote({
              styleClass: 'alert-success',
              heading: 'Success!',
              body: 'User Created'
            });
            this._appService.hideLoader();
          }, 1000);
        },
        error => {
          this._appService.hideLoader();
          this._notifyService.setNote({
            styleClass: 'alert-danger',
            heading: 'Error!',
            body: error
          });
        }
      );
    }
  }

  edit(user) {
    this.uForm.reset();
    this.uForm.get('username').setValue(user.username);
    this.uForm.get('_id').setValue(user._id);
    this.uForm.get('role').setValue(user.role);
    this.uForm.get('saw').setValue(user.saw);
    this.uForm.get('active').setValue(user.active);
    this.uForm.get('firstName').setValue(user.name.full.first);
    this.uForm.get('lastName').setValue(user.name.full.last);
  }

  sortOn(f) {
    if(!this.sortAsc) {
      this.sortAsc = true;
    } else if(this.sortfield == f){
      this.sortAsc = false;
    }
    if(!this.sortAsc) {
     f = '-'+f;
    }
    this.sortfield = f;
  }

  delete(user, i) {
    this._appService.showLoader();
    this._userService.delUser(user).subscribe(
      data => {
        this.users.splice(i, 1);
        setTimeout(()=> {
          this._notifyService.setNote({
            styleClass: 'alert-success',
            heading: 'Success!',
            body: 'User Deleted'
          });
          this._appService.hideLoader();
        }, 1000);
      }
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts